export enum ResponseCode {
  success = 200,
  successNoContent = 204,
  failNoRetry = 201,
  invalidQuery = 400,
  unauthorized = 401,
  forbidden = 403,
  pageNotFound = 404,
  internalError = 500,
  instanceError = 503,
  timeout = 504,
  noProvider = 540,
  noProduct = 541,
  noUser = 542,
  noClient = 543,
  widgetDisabled = 544,
  noOrder = 545,
  noShopper = 546,
  noSocialMediaCollectRequest = 547,
  featureNotEnabled = 548,
  providerDisabled = 549,
}

export enum RequestHeaderKey {
  authorization = 'authorization',
  contentType = 'content-type',
  uri = 'x-request-uri',
  iOSBundleIdentifier = 'x-ios-bundle-identifier',
  cacheControl = 'Cache-Control',
}

export enum RequestHeaderValue {
  contentTypeJSON = 'application/json',
}
